import { customHeaderFunc } from '@/pcomponents/common/date_picker/custom_header';
import { CustomInputSearch } from '@/pcomponents/common/date_picker/custom_input';
import { ko } from "date-fns/esm/locale";
import DateFunc from '@/lib/lyg/date_func';
import DatePicker from "react-datepicker";
import MyScreenFunc from '@/pcomponents/common/screen/func/screen_func';
import strFunc from '@/lib/lyg/string';
import { useNavigate } from 'react-router-dom';
import XcolumnFunc from '@/pcomponents/common/xcolumn/xcolumn/xcolumn_func';

function SearchArea(props: any) {
  let myProps: any = {
    listOpt: {
      s_date_type: "a_date",
      s_start_date: "",
      s_end_date: "",
      s_state: "",
      s_sort: "",
    },
    goDelete: () => { },
    saveSelectedRow: (inData: any) => { },
    open_send_payt_popup: (inData: any) => { },
    open_supply_custom_popup: (inData: any) => { },
    list: (listOpt: any) => { },
    countInfo: {},
    go_excel_down_list: () => { },
    ...props
  };
  const navigate = useNavigate();
  let countInfo = myProps.countInfo;
  let listOpt = myProps.listOpt;
  let is_under_width = MyScreenFunc.get_is_under();
  let select_option_a_pay_sort_arr=XcolumnFunc.getSortByTableKey({'table':'class_supply','key':'a_pay_sort'});

  const onChangeDatePicker = (key: string, date: Date) => {
    let date_str = DateFunc.get_date_format(date, "Y-m-d");
    myProps.setListOpt({
      ...listOpt,
      ...{ [key]: date_str }
    });
    myProps.list({
      now_page: "1",
      ...{ [key]: date_str }
    });
  };

  const handleInputChange = (event: any) => {
    const target = event.target;
    let value = target.value;
    const name = target.name;
    if(target.type == "checkbox") {
      if (target.checked) {
        value = "1";
      } else {
        value = "";
      }
    }

    myProps.setListOpt({
      ...listOpt,
      ...{ [name]: value }
    });
    myProps.list({
      now_page: "1",
      ...{ [name]: value }
    });
  };

  const goDateMonthChange = (sort: any) => {
    //next,pre
    let selected_date = listOpt.s_start_date;
    if (selected_date == "") {
      selected_date = DateFunc.get_date_format(new Date(), "Y-m-d");
    }
    let change_date_obj = new Date(selected_date);
    if (sort == "pre") {
      change_date_obj = DateFunc.get_change_date(new Date(selected_date), 'month', -1);
    } else if (sort == "next") {
      change_date_obj = DateFunc.get_change_date(new Date(selected_date), 'month', +1);
    }

    let start_date = DateFunc.get_date_format(change_date_obj, "Y-m-01");
    let end_date = DateFunc.get_date_format(change_date_obj, "Y-m-t");
    myProps.setListOpt({
      ...listOpt,
      s_start_date: start_date,
      s_end_date: end_date,
    });
    myProps.list({
      now_page: "1",
      s_start_date: start_date,
      s_end_date: end_date,
    });
  };

  const goChangeDateMonth = (month: number) => {
    let selected_date = listOpt.s_start_date;
    if (selected_date == "") {
      selected_date = DateFunc.get_date_format(new Date(), "Y-m-d");
    }
    let row_year = selected_date.substring(0, 4);
    let row_month = strFunc.str_pad({ "str": month, "pad_length": 2 });
    selected_date = row_year + "-" + row_month + "-01";

    let start_date = DateFunc.get_date_format(new Date(selected_date), "Y-m-01");
    let end_date = DateFunc.get_date_format(new Date(selected_date), "Y-m-t");
    myProps.setListOpt({
      ...listOpt,
      s_start_date: start_date,
      s_end_date: end_date,
    });
    myProps.list({
      now_page: "1",
      s_start_date: start_date,
      s_end_date: end_date,
    });
  };

  const change_start_end_date_by_sort = (sort: "this_year" | "this_month" | "pre_month") => {
    let now_month_init_date = DateFunc.get_date_format(new Date(), "Y-m-01");
    let s_start_date = DateFunc.get_date_format(new Date(), "Y-m-d");
    let s_end_date = DateFunc.get_date_format(new Date(), "Y-m-d");
    if (sort == "this_month") {
      s_start_date = DateFunc.get_date_format(new Date(), "Y-m-01");
      s_end_date = DateFunc.get_date_format(new Date(), "Y-m-t");
    } else if (sort == "pre_month") {
      s_start_date = DateFunc.get_date_format(new Date(DateFunc.get_change_date(new Date(now_month_init_date), 'month', -1)), "Y-m-01");
      s_end_date = DateFunc.get_date_format(new Date(DateFunc.get_change_date(new Date(now_month_init_date), 'month', -1)), "Y-m-t");
    } else if (sort == "this_year") {
      s_start_date = DateFunc.get_date_format(new Date(), "Y-01-01");
      s_end_date = "";
    }

    myProps.list({
      now_page: 1,
      s_start_date: s_start_date,
      s_end_date: s_end_date,
    });
  };

  let right_box_class_name = "absolute right-0 top-0 ";
  if (is_under_width) {
    right_box_class_name = "";
  }

  let year_month_num_arr = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];

  return (
    <div className="relative">
      <div className="btn-box-center relative">
        <span className="text-blue-700">
          {listOpt.s_start_date.substring(5, 7)} 월
        </span>
        {year_month_num_arr.map((row_num) => {
          let btn_class_name = "btn btn-dark ml-1";
          let select_month_num = parseInt(listOpt.s_start_date.substring(5, 7));
          if (select_month_num == row_num) {
            btn_class_name = "btn btn-blue ml-1";
          }
          return (
            <button key={row_num} className={btn_class_name}
              onClick={() => { goChangeDateMonth(row_num); }} >{row_num}</button>
          );
        })}
        <button className="btn btn-gray" onClick={() => { goDateMonthChange("pre"); }} >◀</button>
        <button className="btn btn-gray" onClick={() => { goDateMonthChange("next"); }} >▶</button>
        <button className="btn-s btn-dark ml-1"
          style={{ "background": "#0097BA" }}
          onClick={() => { change_start_end_date_by_sort("this_month"); }} >이번달</button>
        <button className="btn-s btn-dark ml-1"
          style={{ "background": "#0097BA" }}
          onClick={() => { change_start_end_date_by_sort("pre_month"); }} >지난달</button>
        <button className="btn-s btn-dark ml-1"
          style={{ "background": "#0097BA" }}
          onClick={() => { change_start_end_date_by_sort("this_year"); }} >올해</button>
        <span style={{ width: 100 }}>
          <DatePicker
            selected={listOpt.s_start_date != "" ? new Date(listOpt.s_start_date) : null}
            onChange={(date: Date) => {
              onChangeDatePicker("s_start_date", date);
            }}
            locale={ko}
            dateFormat="yyyy-MM-dd"
            customInput={<CustomInputSearch />}
            renderCustomHeader={customHeaderFunc}
          />
        </span>~
        <span style={{ width: 100 }}>
          <DatePicker
            selected={listOpt.s_end_date != "" ? new Date(listOpt.s_end_date) : null}
            onChange={(date: Date) => {
              onChangeDatePicker("s_end_date", date);
            }}
            locale={ko}
            dateFormat="yyyy-MM-dd"
            customInput={<CustomInputSearch />}
            renderCustomHeader={customHeaderFunc}
          />
        </span>
      </div>
      <div className="btn-box-center relative mt-1">
        <select className="search-input_select" name="s_date_type" value={listOpt.s_date_type} onChange={handleInputChange} >
          <option value="a_date">청구일</option>
          <option value="a_pay_date">수납일</option>
        </select>
        <select className="search-input_select" name="s_state" value={listOpt.s_state} onChange={handleInputChange} >
          <option value="">수납상태</option>
          <option value="complete">완납</option>
          <option value="unpay">미납</option>
        </select>
        <select className="search-input_select" name="s_sort" value={listOpt.s_sort} onChange={handleInputChange} >
          <option value="">수납구분</option>
          <option value="class">수업</option>
          <option value="etc">기타</option>
        </select>
        <select className="search-input_select" name="s_pay_sort" value={listOpt.s_pay_sort} onChange={handleInputChange} >
          <option value="">결제수단</option>
          {select_option_a_pay_sort_arr.map((item:any,idx:number)=>{
            return (
              <option key={idx} value={item.value}>{item.text}</option>
            );
          })}
        </select>
        <select className="search-input_select" name="s_pay_is_card" value={listOpt.s_pay_is_card} onChange={handleInputChange} >
          <option value="">카드결제</option>
          <option value="1">카드</option>
          <option value="empty">아니오</option>
        </select>
        <input type="text" className="search-input" name="s_stu_name_like" value={listOpt.s_stu_name_like}
          onChange={handleInputChange}
          autoComplete="off" placeholder="이름"
          style={{ width: 100 }} />
        <button className="btn btn-dark" onClick={() => { myProps.list({ now_page: "1" }); }}>검색</button>

        <div className={right_box_class_name}>
          <div className="my_flex_right">
            <button className="btn btn-dark" onClick={() => { myProps.saveSelectedRow({}); }}>저장</button>
            <button className="btn btn-dark" onClick={() => { myProps.open_send_payt_popup({}); }}>청구서전송</button>
            <button className="btn btn-red" onClick={myProps.goDelete}>삭제</button>
            <button className="btn btn-dark" onClick={() => { myProps.go_excel_down_list(); }} >엑셀</button>
            <button className="btn btn-dark" onClick={() => { myProps.open_supply_custom_popup({}); }} >수동추가</button>
            <button className="btn btn-dark" onClick={() => { navigate("/comp/supply/multy_add"); }} >학생별추가</button>
          </div>
        </div>
      </div>
      <div className="list-table-div mt-1">
        <table style={{ margin: "0 auto", width: "auto" }} >
          <tbody>
            <tr>
              <th>
                <span>완료</span>
              </th>
              <td className="text-center" >
                <div style={{ minWidth: 50 }}>
                  {strFunc.comma(countInfo.complete_cnt)}/{strFunc.comma(countInfo.tot)}
                </div>
              </td>
              <th>
                <span>청구</span>
              </th>
              <td className="text-center" >
                <div style={{ minWidth: 70, color: "blue" }}>
                  {strFunc.comma(countInfo.a_money_sum)}원
                </div>
              </td>
              <th>
                <span>입금</span>
              </th>
              <td className="text-center" >
                <div style={{ minWidth: 70, color: "green" }}>
                  {strFunc.comma(countInfo.a_pay_money)}원
                </div>
              </td>
              <th>
                <span>미납(청구일지남)</span>
              </th>
              <td className="text-center" >
                <div style={{ minWidth: 70, color: "red" }}>
                  {strFunc.comma(countInfo.after_unpay_money)}원
                </div>
              </td>
              <th>
                <span>미납(청구일전)</span>
              </th>
              <td className="text-center" >
                <div style={{ minWidth: 70, color: "red" }}>
                  {strFunc.comma(countInfo.pre_unpay_money)}원
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
}
export default SearchArea;